import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const imgA = 'https://websiteoss.ecoflow.com/upload/image/1725006663974/Frame%201000009036%20(1).jpg';

    return (
        <div className={`${styles.TheComp} GtmModuleData-section `} data-section-id="D3-NA1" id='D3-NA1'>
            <EfSpec className="spec-x" />
            <div className="info-box">
                <EfIcon pc={imgA} className="SGS2" />
                <p className="desc">{t('NA1_desc')}</p>
            </div>
            <EfSpec className="spec-x" />
        </div>
    );
}
